import { render } from "./channelEdit.vue?vue&type=template&id=5743375a"
import script from "./channelEdit.vue?vue&type=script&lang=js"
export * from "./channelEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/components/channelEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5743375a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5743375a', __exports__)) {
    console.log('reload')
    api.reload('5743375a', __exports__)
  }
  
  module.hot.accept("./channelEdit.vue?vue&type=template&id=5743375a", () => {
    console.log('re-render')
    api.rerender('5743375a', render)
  })

}


export default __exports__